import React, { Fragment } from "react";

import Button from "../shared/Button";

const DeleteFolderConfirmationModal = props => (
  <Fragment>
    <div className="modal__header">
      <span>
        {props.t("modals:deleteFolderConfirmation")}
      </span>
    </div>

    <div className="modal__body">
      <div className="modal__close" onClick={props.handleCloseModal}>
        <svg className="bars-icon" viewBox="0 0 24 24">
          <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
        </svg>
      </div>
      <div className="pa5 tc">
        <Button
          additionalClassName="mr2"
          label={props.t("common:cancelButton")}
          onClick={props.handleCloseModal}
        />
        <Button
          label={props.t("common:deleteButton")}
          icon="i-arrow-right f6"
          onClick={props.handleConfirmModal}
        />
      </div>
    </div>
  </Fragment>
);

export default DeleteFolderConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/modals/DeleteFolderConfirmationModal.js